import { LoanType, LoanStatusType } from '../LoanConstants';
import { GridSettingType } from '@apply/constants';

export const getLoanGridSettingId = (loanTypeId: LoanType, statusId: LoanStatusType) => {
    if (statusId === LoanStatusType.Deleted) {
        return GridSettingType.RecycleBinTable;
    }

    switch (loanTypeId) {
        case LoanType.Construction:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.StandardLoanTable_Approved_Construction;
                case LoanStatusType.Lost:
                    return GridSettingType.StandardLoanTable_Lost_Construction;
                case LoanStatusType.Repaid:
                    return GridSettingType.StandardLoanTable_Repaid_Construction;
                case LoanStatusType.Outstanding:
                    return GridSettingType.StandardLoanTable_Outstanding_Construction;
            }
            break;
        case LoanType.Rental:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.StandardLoanTable_Approved_Rental;
                case LoanStatusType.Lost:
                    return GridSettingType.StandardLoanTable_Lost_Rental;
                case LoanStatusType.Repaid:
                    return GridSettingType.StandardLoanTable_Repaid_Rental;
                case LoanStatusType.Outstanding:
                    return GridSettingType.StandardLoanTable_Outstanding_Rental;
            }
            break;
        case LoanType.BuildRent:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.StandardLoanTable_Approved_BuildRent;
                case LoanStatusType.Lost:
                    return GridSettingType.StandardLoanTable_Lost_BuildRent;
                case LoanStatusType.Repaid:
                    return GridSettingType.StandardLoanTable_Repaid_BuildRent;
                case LoanStatusType.Outstanding:
                    return GridSettingType.StandardLoanTable_Outstanding_BuildRent;
            }
            break;
        case LoanType.FixFlip:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.StandardLoanTable_Approved_FixFlip;
                case LoanStatusType.Lost:
                    return GridSettingType.StandardLoanTable_Lost_FixFlip;
                case LoanStatusType.Repaid:
                    return GridSettingType.StandardLoanTable_Repaid_FixFlip;
                case LoanStatusType.Outstanding:
                    return GridSettingType.StandardLoanTable_Outstanding_FixFlip;
            }
            break;
        case LoanType.Land:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.StandardLoanTable_Approved_Land;
                case LoanStatusType.Lost:
                    return GridSettingType.StandardLoanTable_Lost_Land;
                case LoanStatusType.Repaid:
                    return GridSettingType.StandardLoanTable_Repaid_Land;
                case LoanStatusType.Outstanding:
                    return GridSettingType.StandardLoanTable_Outstanding_Land;
            }
            break;
        case LoanType.Model:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.StandardLoanTable_Approved_Model;
                case LoanStatusType.Lost:
                    return GridSettingType.StandardLoanTable_Lost_Model;
                case LoanStatusType.Repaid:
                    return GridSettingType.StandardLoanTable_Repaid_Model;
                case LoanStatusType.Outstanding:
                    return GridSettingType.StandardLoanTable_Outstanding_Model;
            }
            break;
        case LoanType.MasterNote:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.MasterNotesTable_Approved;
                case LoanStatusType.Lost:
                    return GridSettingType.MasterNotesTable_Lost;
                case LoanStatusType.Repaid:
                    return GridSettingType.MasterNotesTable_Repaid;
                case LoanStatusType.Outstanding:
                    return GridSettingType.MasterNotesTable_Outstanding;
            }
            break;
        case LoanType.SubNoteConstruction:
        case LoanType.SubNoteFixFlip:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.SubNotesTable_Approved;
                case LoanStatusType.Lost:
                    return GridSettingType.SubNotesTable_Lost;
                case LoanStatusType.Repaid:
                    return GridSettingType.SubNotesTable_Repaid;
                case LoanStatusType.Outstanding:
                    return GridSettingType.SubNotesTable_Outstanding;
            }
            break;
        case LoanType.Bridge:
            switch (statusId) {
                case LoanStatusType.Approved:
                    return GridSettingType.StandardLoanTable_Approved_Bridge;
                case LoanStatusType.Lost:
                    return GridSettingType.StandardLoanTable_Lost_Bridge;
                case LoanStatusType.Repaid:
                    return GridSettingType.StandardLoanTable_Repaid_Bridge;
                case LoanStatusType.Outstanding:
                    return GridSettingType.StandardLoanTable_Outstanding_Bridge;
            }
            break;
        default:
            return GridSettingType.StandardLoanTable;
    }
};
